import { computed, ComputedRef, Ref } from 'vue';
import { MultiselectOption, RegardingInstitutionProfile } from '../../../shared/types';

export const useChildFilter = (children: Ref<RegardingInstitutionProfile[]>) => {
  const options: ComputedRef<MultiselectOption[]> = computed(() =>
    children.value.map(
      child =>
        ({
          label: `${child.name} (${child.metadata})`,
          id: child.id,
          trackBy: `${child.name} (${child.metadata})`,
        } as MultiselectOption)
    )
  );

  return {
    options,
  };
};
